export function formatGrade(grade: number, gradeMax: number, digits = 2, separator = '/') {
  return [grade.toFixed(digits), gradeMax.toFixed(digits)].join(separator);
}
